import React, { useRef } from 'react';
import { connect } from 'react-redux';
import getConfig from 'next/config';

import { showProviderSelectAction } from 'redux/modules/tve';
import WithTVEAuthProvider from 'components/TVE/AuthProvider';
import ProviderSelect from 'components/TVE/ProviderSelect';

const {
  publicRuntimeConfig: {
    DISABLE_AUTH_TVE_MSNBC,
  },
} = getConfig();

/**
 *
 * @param {object} props
 * @param {object} props.tve
 */
const mapStateToProps = ({ tve }) => ({
  authenticated: tve.authenticated,
  providerSelectVisible: tve.providerSelectVisible,
});

/**
 *
 * @param {Function} dispatch
 */
const mapActionsToProps = (dispatch) => ({
  /**
   *
   */
  showProviderSelect: () => dispatch(showProviderSelectAction()),
});

/**
 *
 * @param {object} props
 * @param {object} props.authenticated
 * @param {React.ReactNode} props.children
 * @param {string} props.className
 * @param {boolean} props.providerSelectVisible
 * @param {Function} props.showProviderSelect
 * @param {string} props.redirectUrl
 */
const StandaloneSignIn = ({
  authenticated,
  children,
  className,
  providerSelectVisible,
  showProviderSelect,
  redirectUrl,
}) => {
  const iframeRef = useRef();

  /**
   *
   * @param {React.MouseEvent} e
   */
  const handleSignIn = (e) => {
    e.preventDefault();
    showProviderSelect();
  };

  if (authenticated === true || DISABLE_AUTH_TVE_MSNBC) {
    return null;
  }

  return (
    <>
      <WithTVEAuthProvider
        iframeRef={iframeRef}
        disableBackgroundLogin
      />

      {providerSelectVisible && (
        <ProviderSelect
          iframeRef={iframeRef}
          redirectUrl={redirectUrl}
        />
      )}

      <button
        className={className}
        onClick={handleSignIn}
        type="button"
      >
        {children}
      </button>
    </>
  );
};
export default connect(mapStateToProps, mapActionsToProps)(
  StandaloneSignIn,
);
